module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-screen w-full flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gray-100 px-8 py-6 border-b border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('h2', {
    staticClass: "text-gray-800 text-xl font-poppins font-semibold"
  }, [_vm._v("\n          Genie Prompts (" + _vm._s(_vm.app_genie_prompts.length) + ")\n        ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "bg-blue-500 px-3 py-2 text-white",
    on: {
      "click": function($event) {
        return _vm.handleGoOpenAIPlataform()
      }
    }
  }, [_vm._v("\n        Open AI Plataform\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow h-full overflow-y-auto py-6 px-8"
  }, [_c('ul', {
    staticClass: "flex flex-col space-y-3"
  }, _vm._l((_vm.app_genie_prompts), function(prompt, index) {
    return _c('li', {
      key: index,
      staticClass: "bg-gray-50 border border-solid border-gray-200 px-4 py-3 flex text-pinky cursor-pointer items-center justify-between",
      on: {
        "click": function($event) {
          return _vm.handleOpenPrompt(prompt)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-3"
    }, [_c('i', {
      staticClass: "fa-solid fa-wand-magic-sparkles"
    }), _vm._v(" "), _c('span', {
      staticClass: "hover:underline hover:text-pinky"
    }, [_vm._v("\n            " + _vm._s(prompt.name) + "\n          ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center px-8 py-6"
  }, [_c('button', {
    staticClass: "px-2 py-2 bg-gray-100 text-gray-700 border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      Back to Menu\n    ")]), _vm._v(" "), _c('button')]), _vm._v(" "), (_vm.is_genie_edit_prompt_modal_open === true) ? _c('AdminGeniePrompts', {
    attrs: {
      "name": _vm.selected_genie_prompt.name,
      "prompt_genie": _vm.selected_genie_prompt.prompt,
      "system_prompt": _vm.selected_genie_prompt.system_prompt,
      "user_prompt": _vm.selected_genie_prompt.user_prompt,
      "function_details": _vm.selected_genie_prompt.function_details
    },
    on: {
      "close": function($event) {
        _vm.is_genie_edit_prompt_modal_open = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-poppins font-light"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation text-red-500 mr-1.5"
  }), _vm._v(" Any sudden change can cause problems where the prompt is used! Be careful when using this feature.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-27efd80a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/GeniePrompt/GeniePrompt.vue
// module id = 1942
// module chunks = 61